import React, { useState, useEffect } from 'react';
import Loader from '../Common/Loader';
// import { history } from '../../redux/store';
import constants from '../../constants';
import axios from 'axios';
import { checkRole } from '../Common/CheckRole';
import { Link, useNavigate } from 'react-router-dom';

import { cookieStorageUtility } from '../../utils/utilityFunctions';
const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const List = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [showUILoader, setShowUILoader] = useState(false);
  const [roleId, setRoleId] = useState('');
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    getRoleList();
    // eslint-disable-next-line
  }, []);

  const getRoleList = () => {
    setShowUILoader(true);
    axios(serverUrl + 'roles', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      }
    })
      .then(response => {
        if (response.status === 200) {
          setList(response.data);
        } else {
          setFlag(true);
          setType('error');
          setMessage(response.data.message);
          setTimeout(() => setFlag(false), 5000);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const editRole = (id) => {
    setRoleId(id);
    // navigate('/add_role/',{id: id, type: 'edit'});
    navigate(`/add_role/${id}`);
  };

  const handleSubmit = () => {
    getRoleList();
    setRoleId('');
  };

  const copyRole = (id) => {
    // history.push('/add_role/' + id + '/copy_role');
  };

  const renderList = () => {
    return list.map((val, id) => (
      <div className="table_row border_t_1 border_color_1" key={id}>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5 bld" title="Role name ">
              {val.name}
            </div>
          </div>
        </div>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5 text-capitalize" title="Role name ">{Object.keys(val.permission).join(' | ').replace(/_/g, ' ')}</div>
          </div>
        </div>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5 bld">
              <i
                className="fa fa-pencil fnt15 color7 cursor_p"
                title="Edit"
                onClick={() => editRole(val.id)}
              ></i>
              {/* <Link to={'/add_role/' + val.id}> <i
                className="fa fa-pencil fnt15 color7 cursor_p"
                title="Edit">www</i></Link> */}
              <span className={`pad_lft_rht20 color7 cursor_p ${val.parent_id === null ? '' : 'hides'}`} onClick={() => copyRole(val.id)}>Clone Role</span>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderNewPage = () => (
    <React.Fragment>
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Roles</div>
          </div>
          <div className="col-xs-auto">
             {checkRole('create_role') ? (
              <Link className="ovr btn1 pad_top_bot5 pad_lft_rht15 cursor_p disblock" to='/add_role/'> Add Role</Link>
            ) : ''}
          </div>
        </div>
      </div>
      <div className="container_fluid pad_lft_rht20 padtop25">
        <div className="cover border_all_1 border_color_1">
          <div className="scrolly_auto">
            <div className="table_col table_fixed text-start">
              <div className="table_row bg2_8">
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Name</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Permissions</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Action</div>
              </div>
              {renderList()}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      {showUILoader ? <Loader /> : ''}
      {flag ? (
        <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}>{message}</div>
      ) : ''}
      {renderNewPage()}
    </React.Fragment>
  );
};

export default List;
